import React from "react"

const Footer = () => (
  <footer>
    <p>© 2018-{new Date().getFullYear()} Christopher Muller</p>
  </footer>
)

export default Footer
